/* eslint-disable camelcase */
import { useState } from 'react';
import Checkbox from 'components/global/Checkbox';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { updateClient } from '../../../actions/clients';

function SafteySensitivity({ clientData, updateClient: updateClientAction, intl }) {
  const [safety_sensitive_position_yn, setSafetySensitivePositionYn] = useState(
    () =>
      _.get(clientData, 'personal_detail.safety_sensitive_position_yn'),
  );

  const handleClick = () => {
    const clientID = clientData.id;
    const values = {
      personal_detail: {
        safety_sensitive_position_yn: !safety_sensitive_position_yn,
      },
    };

    updateClientAction(clientID, values, () => {
      setSafetySensitivePositionYn(prev => !prev);
    });
  };

  return (
    <div>
      <Checkbox
        onClick={handleClick}
        checked={safety_sensitive_position_yn}
        name="safety_sensitive_position_yn"
        label={intl.formatMessage({
          defaultMessage: 'Safety Sensitive',
        })}
      />
    </div>
  );
}

SafteySensitivity.propTypes = {
  clientData: PropTypes.object.isRequired,
  updateClient: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(connect(null, { updateClient })(SafteySensitivity));
